//Core
import React, { Component } from "react"

//Images
import ArrowTop from "../../../images/arrow_top.png"

//Style
import style from "./style.module.scss"

//Itils
import jump from "jump.js"

const steps = [
  `Відкрий програму Apple Watch на iPhone і перейди на вкладку «Мій годинник»`,
  `Натисни «Wallet і Apple Pay» `,
  `Щоб додати нову картку обери «Кредитна або дебетова картка»`,
  `При додаванні карт з інших пристроїв чи недавно видалених необхідно їх вибрати, а потім ввести захисний код (CVV2/CVC2) цих карт`,
  `Обери спосіб перевірки своєї картки для Apple Pay (по замовчуванню – це смс повідомлення) та натисни «Далі»`,
  `Після отримання коду-підтвердження введи його у відповідне поле, у разі якщо не відбулася автопідстановка та натисни «Готово»`,
  `Можна починати використовувати Apple Pay на твоєму годиннику!`,
]

const StepList = () => (
  <ul className={style.list}>
    {steps.map((el, index) => (
      <li key={index}>{el}</li>
    ))}
  </ul>
)

export default class AnswerBox extends Component {
  componentDidMount() {
    jump(".set_up", {
      duration: 1000,
      offset: 40,
      callback: undefined,
      a11y: false,
    })
  }

  render() {
    const { click } = this.props
    return (
      <section className={style.answer_wrap}>
        <div className="set_up" />

        <div className="slideOutDown">
          <div className={style.AnswerBox}>
            <img
              className={style.icon}
              onClick={click}
              src={ArrowTop}
              alt="Arrow Top"
            />
            <h2 className={style.title}> Як налаштувати Apple Watch ?</h2>
            <StepList />
          </div>
        </div>

        <div className={style.gradient} />
      </section>
    )
  }
}
